// tslint:disable
export var TCSSiteType;
(function (TCSSiteType) {
    // None
    TCSSiteType[TCSSiteType["None"] = -1] = "None";
    // Facility
    TCSSiteType[TCSSiteType["Facility"] = 0] = "Facility";
    // Infusion
    TCSSiteType[TCSSiteType["Infusion"] = 1] = "Infusion";
    // Pharmacy
    TCSSiteType[TCSSiteType["Pharmacy"] = 2] = "Pharmacy";
})(TCSSiteType || (TCSSiteType = {}));
TCSSiteType['NONE'] = -1;
TCSSiteType['FACILITY'] = 0;
TCSSiteType['INFUSION'] = 1;
TCSSiteType['PHARMACY'] = 2;
//# sourceMappingURL=TCSSiteType.js.map